import { useMemo } from 'react'
import useSWR from 'swr'
import { format } from 'date-fns'

import fetcher from 'utils/fetcher'
import axios from 'utils/axios'
import urlSerialize from 'helpers/browser/urlSerialize'

const useAddressOverrides = ({ params, ruleDetailsFilter }) => {
  const baseEndpoint = '/preferences/address-overrides'
  const endpoint = `${baseEndpoint}?${urlSerialize(params)}`

  const { data, isValidating, mutate } = useSWR(endpoint, fetcher, {
    revalidateOnFocus: false,
  })

  const updatedData = useMemo(() => {
    let rules = data?._embedded?.rules || []
    return rules
  }, [data])

  const createRule = async (values) => {
    const response = await axios.post(baseEndpoint, {
      date_start: values.date_start
        ? format(new Date(values.date_start), 'yyyy-MM-dd')
        : null,
      date_end: values.date_end
        ? format(new Date(values.date_end), 'yyyy-MM-dd')
        : null,
      rule: values.rule,
    })
    mutate()
    return response.data
  }

  const deleteRule = async (id) => {
    const response = await axios.delete(`${baseEndpoint}/${id}`)
    mutate()
    return response.data
  }

  const updateRule = async (id, values) => {
    const {
      headers: { etag },
    } = await axios.head(`${baseEndpoint}/${id}`)

    const response = await axios.patch(
      `${baseEndpoint}/${id}`,
      {
        date_start: values.date_start
          ? format(new Date(values.date_start), 'yyyy-MM-dd')
          : null,
        date_end: values.date_end
          ? format(new Date(values.date_end), 'yyyy-MM-dd')
          : null,
        rule: values.rule,
      },
      {
        headers: { 'If-Match': etag },
      }
    )
    mutate()
    return response.data
  }

  return {
    rules: updatedData,
    allRules: data?._embedded?.rules || [],
    loading: (!data && !data?.error) || isValidating,
    count: updatedData?.length,
    total: updatedData?.length,
    totalPages: Math.ceil(
      updatedData?.length / (params?.['paging[page_size]'] || 20)
    ),
    pageSize: params?.['paging[page_size]'] || 20,
    paginates: data?.paginates,
    validating: isValidating,
    error: data?.error,
    mutate,
    createRule,
    deleteRule,
    updateRule,
  }
}

export default useAddressOverrides
